import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { mq } from '../../styles/vars/media-queries.style'
import { CarouselNavMain } from '../CarouselNav/index.style'

export const CarouselTextSplitWrapper = styled.div`
  background-color: ${props => props.bgColor};
  color: ${props => props.color};
`

export const CarouselTextSplitMain = styled.div`
  -webkit-tap-highlight-color: transparent;
`

export const CarouselTextSplitText = styled.div`
  padding-bottom: 2rem;
  position: relative;
  z-index: 2;

  ${mq.deskL} {
    padding-bottom: 10rem;
  }
`

export const CarouselTextSplitContainer = styled.div`
  ${clamp('margin-right', -22, -49, breakpoints.mobile, breakpoints.contained)};
  overflow: hidden;
  position: relative;
  z-index: 1;

  ${CarouselNavMain} {
    ${clamp('margin-right', 22, 49, breakpoints.mobile, breakpoints.contained)}
  }

  ${mq.desk} {
    ${CarouselNavMain} {
      margin-right: 37%;
      margin-top: -3rem;
    }
  }
`

export const CarouselTextSplitHeading = styled.div`
  pointer-events: all;
`

export const CarouselTextSplitTrack = styled.div`
  position: relative;
  width: 63%;
`
